import {
    collection,
    query,
    where,
    getDocs
} from "firebase/firestore";

import { db } from "../firebaseConfig";

const userCache = new Map();

export const getUserByUsername = async (username) => {

    if (userCache.has(username)) {
        return userCache.get(username);
    }

    const q = query(
        collection(db, "users"),
        where("username", "==", username)
    );

    const snap = await getDocs(q);

    if (snap.empty) return null;

    const doc = snap.docs[0];

    const user = {
        id: doc.id,
        ...doc.data()
    };

    userCache.set(username, user);

    return user;
};